/**
 * @module CourseSelector
 * @description Modulo utilizzato per gestire il selettore link video in fase
 * di correzione esame di un corso acquistato.
 */
const CourseSelector = (() => {

  const init = () => {
    const activator = document.getElementById('lightbox-course-video-link-activator')
    const lightbox = document.getElementById('lightbox-course-video-link')
    const input = document.getElementById('lightbox-course-video-link-input')
    const inputReal = document.getElementById('lightbox-course-video-link-input-real')
    const confirm = document.getElementById('lightbox-course-video-confirm')
    const error = document.getElementById('lightbox-course-video-link-input-error')
    if (!activator) return

    activator.addEventListener('click', (e) => {
      e.preventDefault()

      lightbox.classList.add('is-open')
    })

    input.addEventListener('change', (e) => {
      inputReal.value = e.target.value
      error.setAttribute('style', 'display: none')
    })

    confirm.addEventListener('click', (e) => {
      e.preventDefault()

      if (!inputReal.value.startsWith('http://') && !inputReal.value.startsWith('https://')) {
        error.setAttribute('style', 'display: block')
      } else {
        lightbox.classList.remove('is-open')
      }
    })
  }

  return {
    init
  }
})()

export default CourseSelector


// WEBPACK FOOTER //
// app/javascript/scripts/components/CourseSelector.js